module.exports = __webpack_public_path__ + "static/media/Step1.98be1b30.png";